// extracted by mini-css-extract-plugin
export default {"data-referen-toc":"DataReferenTOC_data-referen-toc__el7Oo"};